<div
  class="product-card-horizontal flex h-full w-full cursor-pointer gap-3 overflow-hidden transition-all duration-300"
  (click)="!isProductAvailable() ? null : addToCart()"
>
  <!-- Product Image Section -->
  <div class="imageContainer relative h-[176px] w-[176px] flex-shrink-0 overflow-hidden">
    <div
      class="absolute inset-0 h-[176px] w-[176px]"
      [appRadialGradient]="product()[ProductKeys.Images]?.thumbnail?.colors"
    ></div>
    <img
      *ngIf="product()[ProductKeys.Images]?.thumbnail"
      [src]="
        product()[ProductKeys.Images]?.thumbnail?.url ||
        product()[ProductKeys.Images]?.cover?.url ||
        '/assets/img/placeholder-product.png'
      "
      [alt]="product()[ProductKeys.Name]"
      class="relative z-10 h-[176px] w-[176px] object-cover transition-transform duration-300"
      loading="lazy"
    />

    <!-- Discount Badge -->
    <div
      *ngIf="displayDiscount()"
      class="absolute left-3 top-3 rounded-full bg-green-500 px-3 py-1 text-sm font-bold text-white shadow-lg"
    >
      {{ discountPercentage() }}%
    </div>

    <!-- Quantity Indicator -->
    <div
      *ngIf="quantity() && quantity()! > 0"
      class="absolute -right-2 -top-2 z-10 flex h-10 w-10 items-center justify-center rounded-full bg-orange-500 text-sm font-bold text-white shadow-lg"
    >
      {{ quantity() }}
    </div>

    <!-- Unavailable Overlay -->
    <div
      *ngIf="!isProductAvailable()"
      class="absolute inset-0 z-30 flex items-center justify-center bg-black bg-opacity-50"
    >
      <span class="text-lg font-bold text-white">{{ '_.UNAVAILABLE' | translate }}</span>
    </div>
  </div>

  <!-- Product Content Section -->
  <div class="flex min-w-0 flex-1 flex-col justify-between">
    <!-- Product Info -->
    <div class="flex flex-1 flex-col">
      <!-- Product Name -->
      <h3
        class="mb-1 line-clamp-2 text-xl font-bold leading-tight"
        [style.color]="(textColor() | contentBuilderColor) || '#333333'"
      >
        {{ product()[ProductKeys.Name] }}
      </h3>

      <!-- Product Description (if available) -->
      <p
        *ngIf="product()[ProductKeys.Description]"
        class="line-clamp-4 text-left text-sm opacity-75"
        [style.color]="(textColor() | contentBuilderColor) || '#666666'"
      >
        {{ product()[ProductKeys.Description] }}
      </p>
    </div>

    <!-- Price and Action Section -->
    <div class="mt-auto flex items-center justify-between">
      <!-- Price -->
      <div class="flex-1">
        <app-price-atom
          [amount]="
            +(
              product()[ProductKeys.PriceToDisplay] ||
              product()[ProductKeys.Discount] ||
              product()[ProductKeys.Price] ||
              0
            )
          "
          [bold]="true"
          size="SM"
          class="text-sm font-bold"
        ></app-price-atom>
      </div>

      <div class="flex items-center">
        @if (product().description?.length || product().allergens?.length) {
          <i
            (click)="!isProductAvailable() ? null : showProductModal(); $event.stopPropagation()"
            class="icon icon-c-info-3 pointer-events-auto mr-[3px] flex items-center justify-center text-lg font-semibold"
            [style.color]="textColor() | contentBuilderColor"
            [class.opacity-50]="!isProductAvailable()"
          ></i>
        }
      </div>
    </div>
  </div>
</div>
